export const FORM_ERROR_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL_NOT_VALID: 'Hmm... that email doesn’t look valid',
};
